var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-3 subitulo",style:('color:'+(_vm.corTexto?_vm.corTexto:'black'))},[_vm._v(_vm._s(_vm.subtitulo))])}
var staticRenderFns = []

export { render, staticRenderFns }